import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWebcomponentsDotOrgComponent } from './simple-icons-webcomponents-dot-org.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWebcomponentsDotOrgComponent ],
    exports:      [ SimpleIconsWebcomponentsDotOrgComponent ],
    bootstrap:    []
})
export class SimpleIconsWebcomponentsDotOrgModule {}
